<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-card-text>
                    <v-container fluid grid-list-form>
                        <v-layout row wrap>
                            <v-flex xs12 sm12>
                                <app-card customClasses="grey lighten-4 pt-4" contentCustomClass="px-0 pt-0 pb-0">
                                    <h2 class="ml-12 mb-12">NOTIFY</h2>
                                </app-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import AppConfig from "Constants/AppConfig";
import app from "Main";
import _ from "lodash";

export default {
    data() {
        return {
            notifications: {},
        };
    },

    computed: {},
    methods: {},
    mounted() {},
};
</script>
